'use client';

import clsx from 'clsx';
import React from 'react';
import { useLang } from '@/hooks/useLang';
import { getPhoneNumberByLocale } from '@/utils';
import { pushGTMEventForATM } from '@/utils/gtm';
import { ATM_LISTING_PHONE_NUMBER_CLICK_EVENT } from '@/utils/gtm/consts';
import { SupportPhoneNumberProps } from './types';
const SupportPhoneNumber: React.FC<SupportPhoneNumberProps> = ({
  location,
  ...props
}) => {
  const lang = useLang();
  const number = getPhoneNumberByLocale(Array.isArray(lang) ? undefined : lang);
  return <a onClick={() => {
    if (!location) {
      return;
    }
    pushGTMEventForATM(location, ATM_LISTING_PHONE_NUMBER_CLICK_EVENT);
  }} className={clsx('block text-body-8 text-gray-500 underline', props.className)} href={`tel:${number}`} {...props} data-sentry-component="SupportPhoneNumber" data-sentry-source-file="index.tsx">
      {number}
    </a>;
};
export default SupportPhoneNumber;